import React from "react";
import { Plug, ExternalLink } from "lucide-react";

export default function Partnerships({ brands = [] }) {
    const partners = brands.filter((b) => b.type === "partner");
    if (partners.length === 0) return null;

    return (
        <section
            id="partnerships"
            data-testid="partnerships-section"
            className="relative py-24 md:py-32 border-t border-white/5 overflow-hidden"
        >
            <div className="absolute top-1/2 right-0 w-[400px] h-[400px] rounded-full bg-brand/8 blur-[140px] pointer-events-none" aria-hidden />

            <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
                    <div>
                        <div className="mono-label mb-4 flex items-center gap-2">
                            <Plug size={11} className="text-brand" /> Partnerships & Integrations
                        </div>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95] tracking-tighter">
                            Platforms I <span className="text-brand">plug into</span>.
                        </h2>
                    </div>
                    <p className="text-ink-200 max-w-md">
                        Third-party platforms, payment gateways, and developer APIs integrated across production environments with proven reliability.
                    </p>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
                    {partners.map((p) => {
                        const card = (
                            <div
                                className="group p-5 rounded-xl border border-white/5 bg-ink-800/40 hover:border-brand/40 hover:bg-ink-800 hover:-translate-y-1 transition-all relative overflow-hidden"
                                data-testid={`partner-${p.name.toLowerCase().replace(/\s|\./g, "-")}`}
                            >
                                <div className="flex items-center gap-3 mb-3">
                                    <div className="w-11 h-11 rounded-lg bg-white/95 flex items-center justify-center overflow-hidden flex-shrink-0">
                                        {p.logo_url ? (
                                            <img
                                                src={p.logo_url}
                                                alt={p.name}
                                                className="w-full h-full object-contain p-1"
                                                onError={(e) => {
                                                    e.currentTarget.style.display = "none";
                                                    e.currentTarget.parentElement.innerHTML = `<span class="font-display text-lg text-black">${p.name[0]}</span>`;
                                                }}
                                            />
                                        ) : (
                                            <span className="font-display text-lg text-black">{p.name[0]}</span>
                                        )}
                                    </div>
                                    <div className="min-w-0">
                                        <div className="text-white font-medium truncate">{p.name}</div>
                                        {p.note && <div className="mono-label truncate text-xs">{p.note}</div>}
                                    </div>
                                    {p.website && (
                                        <ExternalLink size={12} className="ml-auto text-ink-400 group-hover:text-brand transition-colors flex-shrink-0" />
                                    )}
                                </div>
                            </div>
                        );
                        if (p.website)
                            return (
                                <a key={p.id} href={p.website} target="_blank" rel="noreferrer">
                                    {card}
                                </a>
                            );
                        return <div key={p.id}>{card}</div>;
                    })}
                </div>
            </div>
        </section>
    );
}
